import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { AttioObjectDataset } from 'app/model/dataset/attio.dataset';
import {
    TabularTypeDatasetAdapter,
    tabularTypeDatasetAdapts
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AttioObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AttioObjectDatasetAdapter extends TabularTypeDatasetAdapter<
    AttioObjectDataset,
    Model.DatasetResource
> {
    protected override async _toResource(dataset: AttioObjectDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(AttioObjectDataset).name);
    }

    protected override async _toModel(
        resource: Model.DatasetResource,
        dataset?: AttioObjectDataset
    ): Promise<AttioObjectDataset> {
        return this._toModelInternal(resource, dataset, AttioObjectDataset.MODEL);
    }
}
